import { useAuth0 } from '@equipmentshare/auth0-react'
import config from 'config/config'

export type AuthenticatedUser = {
	id: string | null,
	companyId: string | null,
}

/**
 * Hook to get the current authenticated user's ID and company ID from Auth0 JWT claims.
 *
 * Custom claims are namespaced under the API URL (e.g., https://staging-api.equipmentshare.com)
 * The prefix is determined by the REACT_APP_API_URL environment variable, stripping 'staging-'
 * for production deployments.
 *
 * @returns AuthenticatedUser object with id (es_user_id) and companyId (es_company_id)
 */
export function useAuthenticatedUser(): AuthenticatedUser {
	const { user } = useAuth0()

	// Determine the claim prefix based on the API URL
	// Assumes the URL already has a trailing slash (e.g., 'https://staging-api.equipmentshare.com/')
	const claimPrefix = config.API_URL || 'https://staging-api.equipmentshare.com/'

	// Extract the user ID and company ID from custom claims
	const userId = ( user as any )?.[ `${claimPrefix}es_user_id` ] || null
	const companyId = ( user as any )?.[ `${claimPrefix}es_company_id` ] || null

	return {
		id: userId ? String( userId ) : null,
		companyId: companyId ? String( companyId ) : null,
	}
}
